module.exports = __webpack_public_path__ + "static/media/member_manual.57bcf2f3.pdf";